import React, { useState } from "react";
import { Tabs } from "antd";
import { useSelector, useDispatch } from "react-redux";
// import {
//   ChangeStudentTableData,
//   ChangeTrainerSearchText,
// } from "../../../actions/adminAction";
// import { GetTestTableData } from "../../../actions/traineeAction";
// import { ChangeAssignTestModalState } from "../../../actions/trainerAction";
import "./allStudentTest.css";

import SubjectTestData from "./SubjectTestData/SubjectTestData";
import DashboardWrapper from "../shared/DashboardWrapper";

const Student = () => {
  const [tabKey, setTabKey] = useState("Mathematics");

  // Optional: Use the state or dispatch if needed in this component
  // Example: dispatch(ChangeAssignTestModalState(true));

  return (
    <DashboardWrapper title="TAKE TEST">
      <div className="tabs" style={{borderBottom:"none"}}>
        <Tabs
          activeKey={tabKey}
          onChange={(key) => setTabKey(key)}
          tabBarStyle={{ borderBottom: "none" }}
          items={[
            { label: "MATHEMATICS", key: "Mathematics" },
            { label: "ENGLISH", key: "English" },
            { label: "SCIENCE", key: "Science" },
            { label: "MOTHER TONGUE", key: "all" },
          ]}
        />
        {/* Conditionally render SubjectTestData */}
        {(tabKey === "Mathematics" ||
          tabKey === "English" ||
          tabKey === "Science") && (
          <SubjectTestData
            title={tabKey}
          />
        )}
      </div>
    </DashboardWrapper>
  );
};

export default Student;
